import { API_ENDPOINTS } from "../../../../utils/constants";

export const getTransliterateSuggestions = async (word, config) => {
  const { showCurrentWordAsLastSuggestion = true, lang = "hi" } = config || {};

  const TRANSLITRATION_SERVICE_ID = import.meta.env
    .VITE_BHASHINI_TRANSLITRATION_SERVICE_ID;

  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        pipelineTasks: [
          {
            taskType: "transliteration",
            config: {
              language: {
                sourceLanguage: "en",
                targetLanguage: lang,
              },
              serviceId: TRANSLITRATION_SERVICE_ID,
              isSentence: false,
              numSuggestions: 4,
            },
          },
        ],
        inputData: {
          input: [
            {
              source: word,
            },
          ],
        },
      }),
    };

    const res = await fetch(API_ENDPOINTS.transliterate, requestOptions);
    const data = await res.json();
    const result = data?.pipelineResponse?.[0]?.output?.[0]?.target || [];

    if (result.length > 0) {
      const found = showCurrentWordAsLastSuggestion
        ? [...result, word]
        : result;

      return found;
    } else {
      if (showCurrentWordAsLastSuggestion) {
        const fallback = [word];
        return fallback;
      }
      return [];
    }
  } catch (e) {
    console.error("There was an error with transliteration", e);
    return [];
  }
};
